// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2xX8J","content":"LoadingAlert_content__377P9"};